import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeIndex", "children", "className", "hasNavigation", "hasPaging", "horizontalAlign", "id", "mode", "size", "verticalAlign"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, forwardRef, cloneElement, isValidElement, createContext, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Carousel.styles';
import { Navigation, PagingDots } from './components/Controls';
import Slide from './components/Slide';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CarouselContext = createContext();
var Carousel = forwardRef(function (_ref, ref) {
  var _cx;

  var _ref$activeIndex = _ref.activeIndex,
      activeIndexFromProp = _ref$activeIndex === void 0 ? 0 : _ref$activeIndex,
      children = _ref.children,
      customClassName = _ref.className,
      _ref$hasNavigation = _ref.hasNavigation,
      hasNavigation = _ref$hasNavigation === void 0 ? true : _ref$hasNavigation,
      _ref$hasPaging = _ref.hasPaging,
      hasPaging = _ref$hasPaging === void 0 ? true : _ref$hasPaging,
      _ref$horizontalAlign = _ref.horizontalAlign,
      horizontalAlign = _ref$horizontalAlign === void 0 ? 'left' : _ref$horizontalAlign,
      id = _ref.id,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$verticalAlign = _ref.verticalAlign,
      verticalAlign = _ref$verticalAlign === void 0 ? 'top' : _ref$verticalAlign,
      rest = _objectWithoutProperties(_ref, _excluded);

  var containerClassName = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-carousel__container"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useState = useState(activeIndexFromProp),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var slideCount = Children.count(children);
  var slideClones = Children.map(children, function (child, index) {
    if (!isValidElement(child)) return;
    return cloneElement(child, {
      slideIndex: index
    });
  });

  var handleNext = function handleNext() {
    if (activeIndex + 1 < slideCount) {
      setActiveIndex(activeIndex + 1);
    } else {
      setActiveIndex(0);
    }
  };

  var handlePrev = function handlePrev() {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    } else {
      setActiveIndex(slideCount - 1);
    }
  };

  var handleGoToSlide = function handleGoToSlide(index) {
    setActiveIndex(index);
  };

  useEffect(function () {
    setActiveIndex(activeIndexFromProp);
  }, [activeIndexFromProp]);
  return _jsx(CarouselContext.Provider, {
    value: {
      activeIndex: activeIndex,
      hasPaging: hasPaging,
      horizontalAlign: horizontalAlign,
      slideCount: slideCount,
      verticalAlign: verticalAlign
    },
    children: _jsx(ThemeProvider, {
      theme: {
        mode: mode,
        size: size
      },
      children: _jsxs(Styled.Container, {
        ref: ref,
        id: id,
        className: containerClassName,
        children: [hasNavigation && _jsx(Navigation, {
          handleNext: handleNext,
          handlePrev: handlePrev
        }), _jsx(Styled.Carousel, _objectSpread(_objectSpread({
          className: "".concat(prefix, "-carousel"),
          activeIndex: activeIndex
        }, rest), {}, {
          children: slideClones
        })), hasPaging && _jsx(PagingDots, {
          handleGoToSlide: handleGoToSlide
        })]
      })
    })
  });
});
Carousel.Slide = Slide;
export default Carousel;